import axios from "axios";
import { commonHeaders } from "services/httpClient/commonHeader";
import vehicleClient from "services/httpClient/vehicleClients";
import { RequestVehicleInspection, VehicleCancellationProp, vehicleDocsSchema, VehiclePaginationProp } from "styles/types/vehicle";
import TokenService from "../../services/httpClient/tokenManager";
import accountClient from "services/httpClient/accountClient";
import { SendDeviceProp } from "styles/types/device";
import { API_BASE_URL } from "config";

// const baseURL= `https://digitallending.accessbankplc.com:9091`
const baseURL= API_BASE_URL

const headers= commonHeaders

export const getVehicleInfo = (paymentCode: any) => {
  return vehicleClient.get(`/api/Payment/info/${paymentCode.paymentCode}`);
};

const user = JSON.parse(sessionStorage.getItem("userData") || "{}");
  
const  authHeader =() => {
  const token = TokenService.getLocalAccessToken();

  if (token) {
    return {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin':'*',
    };
  } 
}


export const createVehicleInspection = async (body: any) => {
  return await axios.post(
    `${baseURL}/api/Payment/save-payment`,body,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};

export const vehicleMonthlyRepay = async (body: any) => {
  return await axios.post(
    `${baseURL}/api/Loan/vehiclefinance-monthly-repayment`,body,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};

export const createVehicleRequest = async (body: any) => {
  return await axios.post(
    `${baseURL}/api/Payment/finalize`,body,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};

export const getVehicleFinfinanceVendors = async () => {
  return await axios.get(
    `${baseURL}/api/Payment/vehicle-finance-vendors?page=1&limit=10`,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};

export const getVehiclefinanceHistory = async (data:VehiclePaginationProp) => {
  const queryParams = new URLSearchParams({
    pageNumber: data?.pageNumber.toString(),
    pageSize: data?.pageSize.toString(),
    category:data?.category
  });

  // Only include status if it's not 'all'
  if (data?.status !== 'All') {
    queryParams.append('status', data?.status);
  }

  return await axios.get(
    `${baseURL}/api/Payment?${queryParams.toString()}`,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};

export const VehicleRequestCancellation = async (body: VehicleCancellationProp) => {
  return await axios.patch(
    `${baseURL}/api/Payment/cancel-payment-request`,body,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};







